import { appendHeadersWithJSONContentType, customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8UserURL } from 'services/production/utils/getM8URL';
import {
  M8CompanySize,
  M8UserProfile,
  M8UserSex,
} from 'services/production/types';

type Params = {
  firstName: string;
  lastName: string;
  middleName: string;
  organization: string;
  position: string;
  companySize: M8CompanySize;
  phone: string;
  sex: M8UserSex;
  country: string;
  resident: boolean;
  idPartner: null | number;
};

export const confirmDataAndGetTrial = async (
  params: Params
): Promise<M8UserProfile> => {
  const fetchURL = getM8UserURL('confirmDataAndGetTrial');

  const body = JSON.stringify(params);

  const headers = new Headers();
  appendHeadersWithJSONContentType(headers);

  const response = await customFetch(fetchURL, {
    method: 'POST',
    body,
    headers,
  });

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
